<template>
  <section
    class="font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <div class="flex flex-row items-center justify-between gap-4">
      <FlexuilibMagicImg
        src="/layout/instagram.gif"
        alt="instagram logo"
        class="h-10 lg:h-24"
      />
      <h2 class="text-xl font-semibold lg:text-5xl text-center">
        Twoja własna strona <br />
        Twoje zasady
      </h2>

      <FlexuilibMagicImg
        src="/layout/facebook.gif"
        alt="facebook logo"
        class="h-10 lg:h-24"
      />
    </div>

    <p class="mt-6 md:text-xl text-justify">
      Profile na Instagramie i Facebooku są przydatne, ale… nie należą do Ciebie. W każdej
      chwili możesz stracić zasięgi, konto, albo po prostu zniknąć z widoku.
      <strong>
        A aż 63% firm, które polegają tylko na social media, traci kontakt z klientem po
        jednej zmianie algorytmu.
      </strong>
      <br />
      Dlatego własna strona to podstawa – jesteś niezależny, widoczny i masz pełną
      kontrolę nad tym, co widzi klient.
    </p>

    <div class="grid gap-10 mt-8 md:mt-4 md:grid-cols-3">
      <div
        class="flex items-center flex-col justify-center text-center p-8 border border-white rounded-iq-roundness"
      >
        <div class="text-5xl font-bold tabular-nums">
          <CountTo class="inline" :to="63" />
          %
        </div>
        <p class="mt-2 font-extrabold">
          Firm traci kontakt z klientem po jednej zmianie algorytmu
        </p>
      </div>
      <div
        class="flex items-center flex-col justify-center text-center p-8 border border-white rounded-iq-roundness"
      >
        <div class="text-5xl font-bold tabular-nums">
          <CountTo class="inline" :to="53" />
          %
        </div>

        <p class="mt-2 font-extrabold">
          Całego ruchu internetowego trafia z organicznego wyszukiwania (SEO)
        </p>
      </div>
      <div
        class="flex items-center flex-col justify-center text-center p-8 border border-white rounded-iq-roundness"
      >
        <div class="text-5xl font-bold tabular-nums">
          <CountTo class="inline" :to="76" />
          %
        </div>

        <p class="mt-2 font-extrabold">
          lokalnych wyszukań na smartfonie kończy się wizytą w firmie w ciągu 24 h
        </p>
      </div>
    </div>
  </section>
</template>
